import { LandingPageTypesValues } from './types';

export const getClassNameByLandingPageType = (landingPageType: LandingPageTypesValues | null, align?: string) => {
  if (!landingPageType) {
    return '';
  }

  const alignString = align ? `-${align}` : '';
  return `custom-${landingPageType}${alignString}`;
};
